import { computed, inject, Injectable } from '@angular/core';
import { select } from '@ngxs/store';
import { SonaAuthFacade, SonaUsageFacade } from '@sona/angular-auth-domain';
import { Feature } from '@sona/shared-model-common';

@Injectable({
    providedIn: 'root'
})
export class SonaAuthApiFacade {

    /**
     * The authenticated user
     */
    static readonly user = SonaAuthFacade.user;

    private readonly _usageFacade = inject(SonaUsageFacade);

    readonly user = select(SonaAuthFacade.user);
    readonly isAuthenticated = select(SonaAuthFacade.isAuthenticated);
    readonly usage = this._usageFacade.usage;
    readonly subscription = computed(() => this._usageFacade.usage()?.subscription);
    private readonly _features = computed(() => this.subscription()?.features);

    readonly isUsageLimitReached = computed(() => {
        const credits = this.subscription()?.credits ?? 0;

        return credits === -1 ? false : (this.usage()?.creditsUsed ?? 0) >= credits;
    });

    hasPermission(feature: Feature) {
        return computed(() => !!this._features()?.[feature]);
    }

    getFeature(feature: Feature) {
        return computed(() => this._features()?.[feature]);
    }
}
